import { render, staticRenderFns } from "./AppDownloadPanel.vue?vue&type=template&id=082927eb&scoped=true&"
import script from "./AppDownloadPanel.vue?vue&type=script&lang=js&"
export * from "./AppDownloadPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppDownloadPanel.vue?vue&type=style&index=0&id=082927eb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082927eb",
  null
  
)

export default component.exports